import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/manualInvoiceIssueInfo', request)
}

export {get}
